import React from 'react'
import { useDispatch } from 'react-redux'

import { actionSetSelectedItem } from '../../store/actions'
import DefaultGalleryData from '../../libs/default-gallery-data'

import EditGalleryComponent from './edit-gallery'

const NewGalleryComponent = () => {
  const dispatch = useDispatch()
  dispatch(actionSetSelectedItem(DefaultGalleryData))

  return (
    <EditGalleryComponent/>
  )
}

export default NewGalleryComponent
